// extracted by mini-css-extract-plugin
module.exports = {"container":"privacy_container__3m0MG","title":"privacy_title__23K3L","text":"privacy_text__3CuMx"};